import { useAuthTokens } from "api/auth";
import { createAuthorizedFetch } from "api/fetch";

export function useAPIFetch(): typeof fetch {
  const [tokens] = useAuthTokens();
  return createAuthorizedFetch(tokens?.accessToken)
}
